import { deleteMeetingRecord } from "./deleteMeetingRecord";
import { getMeetingRecord } from "./getMeetingRecord";
import { postMeetingRecord } from "./postMeetingRecord";

export const meetingRecordApi = {
  getMeetingRecord,
  postMeetingRecord,
  deleteMeetingRecord
};
